/* @flow */

import * as React from 'react';
import RewriteNavLink from 'app/components/routing/RewriteNavLink';

type Props = {
  children: any,
  activeClassName: string,
  className: string,
  external: boolean,
  location: Object,
  url: string
};

class NavPrimaryLink extends React.PureComponent<Props> {
  props: Props;

  render() {
    const { activeClassName, children, className, external, location, url } = this.props;

    if (external) {
      return (
        <a className={className} href={url} target="blank">
          {children}
        </a>
      );
    }

    return (
      <RewriteNavLink
        to={url}
        activeClassName={activeClassName}
        className={className}
        location={location}
      >
        {children}
      </RewriteNavLink>
    );
  }
}

export default NavPrimaryLink;
